import { TableColumn } from "../table/TableColumn";

const BioEventActionColumns : TableColumn[] = [
    {
        heading:"Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "type"
    },
    {
        heading: "Event Type",
        accessor: "eventType",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "eventType"
    },
    {
        heading: "Message",
        accessor: "message",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "message"
    }
];

export default BioEventActionColumns;
